module.exports = fox._r("images/processing_icon.gif", __webpack_public_path__ + "_/_/_/common/frame/images/processing_icon.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/processing_icon.gif
// module id = 20
// module chunks = 2